import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { Text } from 'Components/frameworks/text/Text';
export type TripadvisorTestimonyProps = {
  author: string;
  className?: string;
  date: string;
  fullCommentLink: string;
  link: CMSLink;
  onBy: string;
  stars: string;
  text: string;
};
const TRIPADVISOR_RATINGS_SVG = {
  '4': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/4.0-24206-5.svg',
  '5': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/5.0-24206-5.svg',
};
export const TripadvisorTestimony = ({
  author,
  className,
  date,
  fullCommentLink,
  link,
  onBy,
  stars,
  text,
  ...rest
}: TripadvisorTestimonyProps) => {
  const track = useTracking({
    actionGA: 'push_content_testimony',
  });
  return (
    <blockquote
      {...rest}
      cite={fullCommentLink}
      className={classnames('m-0 flex flex-col items-center py-15', className)}
    >
      <div className="flex w-full flex-col items-center justify-center md:ltr:flex-row md:rtl:flex-row-reverse">
        <Icon
          className="mb-15 text-blueWave md:me-25 md:self-start"
          hasRtl
          name={ICONS.QUOTATION_MARK}
          width="2rem"
        />
        <DynamicLink
          rel="nofollow"
          onClick={() =>
            track({
              labelGA: 'seeFullComment',
            })
          }
          url={fullCommentLink}
        >
          <Text className="max-w-site-small text-center" text={text} theme="text-brand-n1" />
        </DynamicLink>
        <Icon
          className="ms-25 hidden self-end text-blueWave md:inline-block"
          hasRtl
          name={ICONS.QUOTATION_MARK}
          rotation={180}
          width="2rem"
        />
      </div>
      <p className="flex flex-col items-center justify-center md:ltr:flex-row md:rtl:flex-row-reverse">
        <img alt="" className="my-10 md:my-0 md:me-10" src={TRIPADVISOR_RATINGS_SVG[stars]} />
        <TemplateString
          className="mt-5 text-center"
          dataTestId="tripadvisor-testimony-onby"
          template={onBy}
          values={{
            author,
            date,
          }}
          valuesClassName={{
            author: 'font-bold',
            date: 'font-bold',
          }}
        />
        {link?.url && (
          <DynamicLink
            className="mt-5 text-black underline md:ms-10"
            data-testid="tripadvisor-testimony-seemore"
            onClick={() =>
              track({
                labelGA: 'seeMore',
              })
            }
            rel="nofollow"
            url={link.url}
          >
            {link.label}
          </DynamicLink>
        )}
      </p>
    </blockquote>
  );
};
